import { pathOr, equals, hasPath } from 'ramda';
import { applicationClient } from 'src/graphQLRequest';


export const requestGraphQL = async (query: any, variables: any) => {
    return new Promise(async (resolve, reject) => {
        const data = await useRequestGQLQuery(query, variables)
        if (hasPath(['errors'], data)) {
            reject(data)
            return
        }
        resolve(data)
    })
}

export const useRequestGQLQuery = async (query: any, variables: any) => {

    try {
        const client = await applicationClient()
        const result = await client.request(query, variables);
        return result;
    } catch (error) {
        const status = pathOr('', ['errors', 0, 'extensions', 'code'], error)
        if (equals(status, 'invalid-jwt')) {
            const client = await applicationClient()
            const result = await client.request(query, variables);
            return result;
        }
        //reportException(`<-----useGraphQLQuery-16-----> ${error}`)
        return;
    }
};
